module.exports = __webpack_public_path__ + "img/Pestanas.47c11d9a.svg";